import {attributesApi} from "../../api/attributes";

export default async function attributesData(){
    const response = await attributesApi.getAll();
    return response.data;
}